<template>
  <b-nav-item-dropdown
    variant="link"
    :disabled="!filters.length"
    menu-class="filters-dropdown"
    @hide="hideDropdown($event)"
    no-caret
  >
    <template slot="button-content">
      <div class="d-flex align-items-center">
        <feather-icon icon="FilterIcon" size="18" class="mr-50"/>
        Filters
        <feather-icon icon="ChevronDownIcon" size="14"/>
      </div>
    </template>

    <div class="filters-list" :class="['filters-list--column-' + columnCount]">
      <component
        v-for="(filter, index) in filters"
        :key="index"
        :is="filter.type + '-filter'"
        :filter="filter"
        :removeFilter="removeFilter"
        :selectedFilters="selectedFilters"
        class="filters-list__item"
        @value-updated="$emit('refetch-data')"
        @option:deselected="deselectedOption"
      />
    </div>
  </b-nav-item-dropdown>
</template>

<script>
import {BCol, BRow, BNavItemDropdown} from 'bootstrap-vue'

import TagsFilter from '../filters/Tags';
import SearchFilter from '../filters/Search';
import SelectFilter from '../filters/Select';
import SelectAutocompleteFilter from '../filters/SelectAutocomplete';
import DateRangeFilter from '../filters/DateRange';

export default {
  inject: ['fetchFilterOptions'],
  components: {
    BCol,
    BRow,
    BNavItemDropdown,
    TagsFilter,
    SearchFilter,
    SelectFilter,
    SelectAutocompleteFilter,
    DateRangeFilter,
  },
  props: {
    columnCount: {
      type: Number,
      default: 2
    },
    filters: {
      type: Array,
      required: true
    },
    selectedFilters: {
      type: Array,
      required: true
    },
    removeFilter: {
      type: Object
    }
  },
  data() {
    return {
      deselected: false
    }
  },
  computed: {
    hasErrors() {
      return this.filters.some(filter => filter.errors)
    },
  },
  methods: {
    deselectedOption(val) {
      this.deselected = val;
    },
    hideDropdown(event) {
      if (this.deselected) {
        event.preventDefault();
      }
      this.deselected = false;
    }
  }
}
</script>

<style lang="scss">

$filter-width: 230px;
$filter-spacing: 20px;

$column-1-width: $filter-width + $filter-spacing * 2;
$column-2-width: $filter-width * 2 + $filter-spacing * 3;
$column-3-width: $filter-width * 3 + $filter-spacing * 4;
$column-4-width: $filter-width * 4 + $filter-spacing * 5;

.filters-list {
  display: flex;
  flex-wrap: wrap;
  padding: $filter-spacing !important;
  padding-right: 0 !important;;

  &__item {
    margin-right: $filter-spacing;
    width: $filter-width;
  }

  &--column-1 {
    width: $column-1-width;
  }

  &--column-2 {
    width: $column-2-width;
  }

  &--column-3 {
    width: $column-3-width;
  }

  &--column-4 {
    width: $column-4-width;
  }
}

@media (max-width: 1340px) {
  .filters-list {
    max-width: $column-3-width !important;
  }
}

@media (max-width: 860px) {
  .filters-list {
    max-width: $column-2-width !important;
  }
}

@media (max-width: 570px) {
  .filters-list {
    max-width: $column-1-width !important;
  }
}
</style>
